import Vue from 'vue';
import ApiUrl from '../apiurl';

export default {
    namespaced: true,
    state: {
        daliyReportList: [],
        monthlyReportList: [],
        spyReportList: [],
    },
    getters: {
        daliyReportList: (state) => {
            return state.daliyReportList;
        },
        monthlyReportList: (state) => {
            return state.monthlyReportList;
        },
        spyReportList: (state) => {
            return state.spyReportList;
        }
    },
    mutations: {
        setDaliyReportList(state, newValue) {
            if (Array.isArray(newValue)) {
                Vue.set(state, 'daliyReportList', [...newValue]);
            }
        },
        setMonthlyReportList(state, newValue) {
            if (Array.isArray(newValue)) {
                Vue.set(state, 'monthlyReportList', [...newValue]);
            }
        },
        setSpyReportList(state, newValue) {
            if (Array.isArray(newValue)) {
                Vue.set(state, 'spyReportList', [...newValue]);
            }
        },



    },
    actions: {

        async loadSpyReport({ commit }, { postData, handle }) {
            try {
                commit('startLoading', null, { root: true });
                const rsp = await axios.post(ApiUrl.report.espionage, postData);
                if (rsp && rsp.data) {
                    commit('setSpyReportList', rsp.data);
                    handle && handle(true);
                }

            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },
        async loadDaliyReport({ commit }, { start, end }) {
            try {
                var postData = {
                    start: start,
                    end: end
                };
                commit('startLoading', null, { root: true });
                const rsp = await axios.post(ApiUrl.report.daily, postData);
                if (rsp && rsp.data) {
                    //  alert(JSON.stringify(rsp.data));           
                    commit('setDaliyReportList', rsp.data);
                }

            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }

        },

        async loadMonthlyReport({ commit }, { start, end }) {
            try {
                commit('startLoading', null, { root: true });
                const rsp = await axios.post(ApiUrl.report.monthly, { 'start': start, "end": end });
                if (rsp && rsp.data) {
                    commit('setMonthlyReportList', rsp.data);

                }

            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }

        }
    }
}